import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

/* ------------- Collection reducer ------------- */
const defaultState = {
  loaded: false,
  loading: false,
  list: null,
  modalOpen: false,
  page: 1,
  search: null,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.LOAD_START: {
      const { page, search } = action.payload;
      return state.merge({
        page, search, loaded: false, loading: true,
      });
    }
    case actions.LOAD_SUCCESS: {
      return state.merge({ loaded: true, loading: false, list: action.payload.list });
    }
    case actions.LOAD_FAIL: {
      return state.merge({ loaded: true, loading: false });
    }
    case actions.OPEN_MODAL: {
      return state.merge({ modalOpen: true });
    }
    case actions.CLOSE_MODAL: {
      return state.merge({ modalOpen: false });
    }
    case actions.ADD_COLLECTION: {
      const oldList = state.list || [];
      const list = Immutable([action.payload.collection, ...oldList]);
      return state.merge({ list, modalOpen: false });
    }
    case actions.UPDATE_COLLECTION: {
      const { payload } = action;
      const oldList = state.list || Immutable([]);
      const list = oldList.map(collection => (
        collection.id === payload.collection.id ? payload.collection : collection
      ));
      return state.merge({ list, modalOpen: false });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- Auth propTypes ------------- */
export const propTypes = {
};



// WEBPACK FOOTER //
// ./src/redux/ProductCollections/reducer.js